import { actions } from './Reducer';
/**
 * Actions that fire saga watchers
 */

// Singular
export const updatePendingSupplierAction = body => ({
  type: actions.UPDATE_PENDING_SUPPLIER,
  payload: body
});

// Plural
export const getPendingSuppliersAction = body => ({
  type: actions.GET_PENDING_SUPPLIERS,
  payload: body
});

export const getSinglePendingSupplierAction = id => ({
  type: actions.GET_SINGLE_PENDING_SUPPLIER,
  payload: id
});

export const deleteSinglePendingSupplierAction = id => ({
  type: actions.DELETE_SINGLE_PENDING_SUPPLIER,
  payload: id
});

export const moderateCreateSinglePendingSupplier = (id, mode) => ({
  type: actions.MODERATE_CREATE_SINGLE_PENDING_SUPPLIER,
  payload: id,
  mode
});
/**
 * Actions that are fired by redux-saga watchers
 */

// Singular
export const updatePendingSupplierSuccessAction = supplier => ({
  type: actions.UPDATE_PENDING_SUPPLIER_SUCCESS,
  payload: supplier
});

export const getSinglePendingSupplierSuccessAction = supplier => ({
  type: actions.GET_SINGLE_PENDING_SUPPLIER_SUCCESS,
  payload: supplier
});

export const deleteSinglePendingSupplierSuccessAction = id => ({
  type: actions.DELETE_SINGLE_PENDING_SUPPLIER_SUCCESS,
  payload: id
});

export const moderateCreateSinglePendingSupplierSuccessAction = id => ({
  type: actions.MODERATE_CREATE_SINGLE_PENDING_SUPPLIER_SUCCESS,
  payload: id
});
// Plural
export const getPendingSuppliersSuccessAction = suppliers => ({
  type: actions.GET_PENDING_SUPPLIERS_SUCCESS,
  payload: suppliers
});

/**
 * Misc
 */

export const setPendingSuppliersIsLoadingAction = isLoading => ({
  type: actions.SET_PENDING_SUPPLIERS_IS_LOADING,
  payload: isLoading
});

export const setPendingSuppliersCountAction = count => ({
  type: actions.SET_PENDING_SUPPLIERS_COUNT,
  payload: count
});
